import './Categories.css';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import db from '../../Core/firebaseCore';

function Categories() {
    const [categories, setCategories] = useState([]);
    useEffect(() => {
        //= Fetch categories from cloud
        const fetchCategories = async () => {
            const collection = await db.collection("categories").where('active', '==', true).get();
            let categories_local = collection.docs.map((doc) => {
                let _data = doc.data();
                _data.id = doc.id;
                return _data;
            });
            setCategories(categories_local);
        }
        fetchCategories();
    }, []);

    return (
        <div className="categories">
            <nav className="categories">
                <div className="nav-wrapper">
                    <ul id="nav-mobile" className="hide-on-med-and-down">
                        {categories.map((category) => {
                            return (<li key={category.id} id={category.id}><Link to={"/videos/" + category.id}>{category.name}</Link></li>)
                        })}
                    </ul>
                </div>
            </nav>
        </div >
    )
}

export default Categories
